import React from "react";
import { Outlet } from "react-router-dom";
// ADJUST these two paths to wherever Nav.jsx and Footer.jsx live in your tree,
// e.g. "../navigation/Nav" and "../footer/Footer" if you kept the old folders.
import Nav from "../nav/Nav";
import Footer from "../footer/Footer";
/**
 * The structural frame every route renders inside.
 *
 *   .shell        display:flex        <- the parent DevTools said was missing
 *   |- Nav        sidebar (desktop) or topbar (mobile)
 *   |- .shell-main  flex column: page grows, footer sits at the bottom
 *      |- main     your `main { flex: 1 1 auto; min-width: 0 }` rule
 *      |  |- <Outlet/>   the current page
 *      |- Footer
 *
 * Without .shell, the 100vh sticky sidebar is a full-width block: content
 * starts a viewport down, and on scroll the pinned sidebar overlaps it.
 */
export default function Layout() {
  return (
    <div className="shell">
      <Nav />
      <div className="shell-main">
        <main>
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
}